import type { KokubanInfo } from "@/types/kokubanApiDef"
import type { ConstructionAccountInfo } from "@/types/constructionApiDef"
import moment from 'moment'

// 黒板へのアクセス権があるか？
export const isKokubanAccessPermissions = (kokuban: KokubanInfo, constructionAccountInfo: ConstructionAccountInfo) => {
  // 管理者
  if(constructionAccountInfo.role_type === 'manager') return true
  // 一般でも見れるアカウント（作成直後には、shared_account_ids := [ 作成者 ] となる）
  if (kokuban.shared_account_ids && 
      kokuban.shared_account_ids.indexOf(constructionAccountInfo.account_id) !== -1) return true
  return false
}

// 黒板一覧に表示される
export const isDisplayOnKokubanList = (kokuban: KokubanInfo) => {
  if(kokuban.hidden_at) return false
  if(kokuban.deleted_at) return false
  return true
}
// 黒板削除済み一覧に表示する
export const isDisplayOnKokubanDeletedList = (kokuban: KokubanInfo) => {
  if(kokuban.hidden_at) return false
  if(!kokuban.deleted_at) return false

  // 現在時刻を取得
  const currentMillis = moment().valueOf();
  const limitTime = moment(currentMillis)
  limitTime.add(-30, 'days')
  if(limitTime.valueOf() < kokuban.deleted_at) return true

  return false
}